<section class="bn-case-group flex flex-col gap-1">
  <button
    type="button"
    class="bn-case-group__header flex items-center gap-3 w-full text-left"
    [attr.aria-expanded]="!collapsed()"
    (click)="toggle()"
  >
    <span class="bn-case-group__chevron" aria-hidden="true">
      <i class="pi" [class.pi-chevron-down]="!collapsed()" [class.pi-chevron-right]="collapsed()"></i>
    </span>
    @if (statusKey(); as status) {
      <span class="bn-case-group__dot" [class]="'bn-case-group__dot--' + status" aria-hidden="true"></span>
    }
    <span class="bn-case-group__label">{{ group().label }}</span>
    <span class="bn-case-group__meta">{{ caseCountLabel() }}</span>
  </button>

  @if (!collapsed()) {
    <div class="bn-case-group__list flex flex-col">
      @for (c of group().cases; track c.id) {
        <bn-case-card [case]="c" />
      }
    </div>
  }
</section>
